export function sleep(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function isGitHubWrite409(err: unknown): boolean {
  const m = err instanceof Error ? err.message : String(err);
  return /\b409\b/.test(m) || m.includes('"status":"409"') || m.includes('"status": "409"');
}

/** GitHub 409 bodies often include a 40-char blob id in the `message` string; use as a SHA hint for one retry. */
export function parseBlobShaHintFromGithub409(err: unknown): string | undefined {
  const msg = err instanceof Error ? err.message : String(err);
  const idx = msg.indexOf('{');
  if (idx === -1) return undefined;
  try {
    const o = JSON.parse(msg.slice(idx)) as { message?: string };
    const inner = o.message;
    if (typeof inner !== 'string') return undefined;
    const matches = [...inner.matchAll(/\b([a-f0-9]{40})\b/gi)];
    const last = matches[matches.length - 1];
    return last?.[1]?.toLowerCase();
  } catch {
    return undefined;
  }
}
